{
  "salon-search-form-advance-dialog": {
    "buttons": {
      "cancel": "Annuler",
      "save": "Économiser"
    },
    "text": {
      "title": "Filtre d'avance",
      "kilometer": "Kilomètres",
      "only-salon-with-discount": "Remise seulement",
      "only-salon-with-discount-description": "Salon réservé aux visiteurs et offrant des services à prix réduits",
      "radius": "Rayon",
      "radius-description": "Distance entre les salons et l'endroit souhaité",
      "sort-by": "Trier par",
      "sort-by-distance": "Distance",
      "sort-by-distance-description": "Le salon le plus proche de l'endroit souhaité sera affiché en premier",
      "sort-by-rating": "Note",
      "sort-by-rating-description": "Le salon le mieux noté sera affiché en premier"
    }
  }
}
